import { render, staticRenderFns } from "./Terminal2.vue?vue&type=template&id=59a61a6c&scoped=true"
import script from "./Terminal2.vue?vue&type=script&lang=js"
export * from "./Terminal2.vue?vue&type=script&lang=js"
import style0 from "./Terminal2.vue?vue&type=style&index=0&id=59a61a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a61a6c",
  null
  
)

export default component.exports